import PageStaticTemplate from './PageStaticTemplate';

const PageStaticDemo1 = ({ overlay }) => {
    return <PageStaticTemplate page='static.help.support' apiUrl='/static-pages/631efa9f23a8f9a3f1ffeec1' icon='Support1' overlay={overlay} />;
};

export default PageStaticDemo1;
